import React from 'react';

const VintageDescription = ({ wineDetails }) => {
  const {
    VintageNotes
  } = wineDetails || {};

  return (
    <section>
      {VintageNotes &&
        <div className="row">
          <div className="col-md-6 offset-md-1">
            <h2 className="section">Vintage Description</h2>
            <div dangerouslySetInnerHTML={{ __html: VintageNotes }} />
          </div>
        </div>}
    </section>
  );
};

export default VintageDescription;
